import { Route } from '@utils/types';
import React from 'react';
import { ProtectedRoute } from '@components/guards/ProtectedRoute';

// Login flow components
const EnterPhone = React.lazy(() => import('@components/login/enter-phone'));
const VerifyOtp = React.lazy(() => import('@components/login/verify-otp'));
const CardDetailsForm = React.lazy(
  () => import('@components/login/card-details-form'),
);

// City/Lounge selection components (combined in accordion)
const CityLoungeSelection = React.lazy(
  () => import('@components/city-lounge-selection'),
);

// Page components
const AvailableBenefits = React.lazy(() => import('@pages/available-benefits'));
const PaymentStatus = React.lazy(() => import('@pages/payment-status'));
const ReceiptQR = React.lazy(() => import('@pages/receipt-qr'));
const NotFound = React.lazy(() => import('@pages/not-found'));
const MyBookings = React.lazy(() => import('@pages/my-bookings'));
const TermsAndConditions = React.lazy(() => import('@pages/terms-conditions'));

// Auth routes (login pages with split-screen layout)
export const authRoutes: Route[] = [
  {
    path: '/login/phone',
    key: 'login-phone',
    element: <EnterPhone />,
  },
  {
    path: '/login/verify-otp',
    key: 'login-verify-otp',
    element: <VerifyOtp />,
  },
];

// Main routes (with header layout)
// Note: '/' is handled directly in App.tsx to avoid rendering inside <Layout>
export const routes: Route[] = [
  {
    path: '/select-city',
    key: 'select-city',
    element: (
      <ProtectedRoute>
        <CityLoungeSelection />
      </ProtectedRoute>
    ),
  },
  {
    path: '/card-details/:loungeId',
    key: 'card-details',
    element: (
      <ProtectedRoute>
        <CardDetailsForm />
      </ProtectedRoute>
    ),
  },
  {
    path: '/booking/:loungeId',
    key: 'booking',
    element: (
      <ProtectedRoute>
        <AvailableBenefits />
      </ProtectedRoute>
    ),
  },
  {
    path: '/my-bookings',
    key: 'my-bookings',
    element: (
      <ProtectedRoute>
        <MyBookings />
      </ProtectedRoute>
    ),
  },
  {
    path: '/payment-status/:transactionId',
    key: 'payment-status',
    element: (
      <ProtectedRoute>
        <PaymentStatus />
      </ProtectedRoute>
    ),
  },
  {
    path: '/receipt/:transactionId',
    key: 'receipt-qr',
    element: (
      <ProtectedRoute>
        <ReceiptQR />
      </ProtectedRoute>
    ),
  },
  {
    path: '/terms-conditions',
    key: 'terms-conditions',
    element: <TermsAndConditions />,
  },
  {
    path: '*',
    key: 'not-found',
    element: <NotFound />,
  },
];
